import request from '@/utils/request';
// pdd店铺授权
export function pddMallAuthorizeApi(data) {
  return request({
    url: '/ecom/pddOrder/mallAuthorize',
    method: 'post',
    data
  });
}
// wd店铺授权
export function wdMallAuthorizeApi(data) {
  return request({
    url: '/customerWdOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// Mgj 店铺授权
export function mgjMallAuthorizeApi(data) {
  return request({
    url: '/customerMgjOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// Beibei 店铺授权
export function beibeiMallAuthorizeApi(data) {
  return request({
    url: '/customBeiBOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// JP 店铺保存商品Key
export function jpMallSaveCustomerKeyApi(data) {
  return request({
    url: '/customerJpOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// 国美 店铺授权
export function gomeAuthenticationApi(data) {
  return request({
    url: '/customerGomeOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// 有赞店铺授权
export function youzanAuthenticationApi(data) {
  return request({
    url: '/customerYzOrders/mallAuthorize',
    method: 'post',
    data
  });
}
// 得物授权--保存key
export function dewuMallSaveCustomerKeyApi(data) {
  return request({
    url: '/ecom/dewu/mallAuthorize',
    method: 'post',
    data
  });
}

//b站授权-保存key
export function blblMallSaveCustomerKeyApi(data) {
  return request({
    url: '/ecom/blbl/mallAuthorize',
    method: 'post',
    data
  });
}
// 鲁班授权--保存key
export function lubanMallSaveCustomerKeyApi(data) {
  return request({
    url: '/ecom/luban/mallAuthorize',
    method: 'post',
    data
  });
}
export function dydfMallSaveCustomerKeyApi(data) {
  return request({
    url: '/ecom/dydf/mallAuthorize',
    method: 'post',
    data
  });
}
// 苏宁授权--保存key
export function suningMallSaveCustomerKeyApi(data) {
  return request({
    url: '/ecom/sn/mallAuthorize',
    method: 'post',
    data
  });
}
// 快手店铺授权
export function kuaishouAuthenticationApi(data) {
  return request({
    url: '/ecom/ks/mallAuthorize',
    method: 'post',
    data
  });
}
// 快手店铺授权
export function kuaishouAuthenticationForGetApi(data) {
  return request({
    url: '/oauth/callback/ks?' + data,
    method: 'get'
  });
}
// 快手店铺授权
export function kuaishouAuthenticationForPostApi(data) {
  return request({
    url: '/ecom/ks/mallServiceAuthorize',
    method: 'post',
    data
  });
}
// 获取店铺列表
export function getStoreListApi(data) {
  return request({
    url: '/ecom/common/queryMall',
    method: 'post',
    data: data
  });
}
// 电子面单得物店铺授权
export function mallCodeWayBillDewuApi(data) {
  return request({
    url: '/ecom/dewu/mallCodeWayBill',
    method: 'post',
    data
  });
}
// 电子面单LUBAN店铺授权
export function mallCodeWayBillLubanApi(data) {
  return request({
    url: '/ecom/luban/mallCodeWayBill',
    method: 'post',
    data
  });
}
// 电子面单pdd店铺授权
export function pddMallCodeWayBillApi(data) {
  return request({
    url: '/ecom/pddOrder/mallCodeWayBill',
    method: 'post',
    data
  });
}
// 电子面单快手店铺授权
export function mallCodeWayBillKsApi(data) {
  return request({
    url: '/ecom/ks/mallCodeWayBill',
    method: 'post',
    data
  })
}
// 电子面单微信小店店铺授权
export function mallCodeWayBillWxApi(data) {
  return request({
    url: '/ecom/wxsph/mallCodeWayBill',
    method: 'post',
    data
  })
}
// 删除电子面单
export function deleteWaybillApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/unBindWaybill',
    method: 'post',
    data
  });
}
// 抖音厂商代发网点查询
export function lubanDFShopListApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/lubanDFShopList',
    method: 'post',
    data
  });
}
// 删除店铺
export function deleteMallApi(data) {
  return request({
    url: '/ecom/common/delMall',
    method: 'post',
    data
  });
}
// 小红书--电子面单账号授权 鉴权
export function xiaohsMallCodeWayBillApi(data) {
  return request({
    url: '/customerXiaohsOrders/mallCodeWayBill',
    method: 'post',
    data
  })
}
// 有赞 鉴权
export function yzMallCodeWayBillApi(data) {
  return request({
    url: '/customerYzOrders/mallCodeWayBill',
    method: 'post',
    data
  })
}
// 小红书--电子面单账号 查询余额
export function xiaohsWaybillBalanceApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/xiaoHsShopBalanceList',
    method: 'post',
    data
  })
}
// 有赞 电子面单账号 余额
export function yzBalanceListApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/yzBalanceList',
    method: 'post',
    data
  })
}
// 小红书店铺鉴权
export function xiaohsMallAuthorizeApi(data) {
  return request({
    url: '/customerXiaohsOrders/authorize?code=' + data,
    method: 'get'
  });
}
// 微信小店授权
export function wxMallAuthorizeApi(data) {
  return request({
    url: '/ecom/wxsph/mallServiceAuthorize',
    method: 'post',
    data
  });
}
// 微信小店token获取
export function wxGetTokennApi(data) {
  return request({
    url: '/oauth/callback/wxsph?state=wxsph&code=' + data,
    method: 'get'
  });
}

// 微信供货商授权
export function wxgysMallAuthorizeApi(data) {
  return request({
    url: '/ecom/wxgys/mallAuthorize',
    method: 'post',
    data
  });
}
// 微信供货商token获取
export function wxgysGetTokennApi(data) {
  return request({
    url: '/oauth/callback/wxgys?state=wxgys&code=' + data,
    method: 'get'
  });
}

// 京东满意度token获取
export function jdBasicGetEncryptTokenApi(data) {
  return request({
    baseURL: '/jd-api/',
    url: '/jdCloud/jdBasic/getEncryptToken',
    method: 'post',
    data
  });
}
